import React from "react";

const Second = ({ msg, color }) => {
  return (
    <>
      <ul class="list-disc pl-4 md:p-10 space-y-3 text-gray-500 mt-2">
        <span>
          Kila Katiba ya chama inatakiwa kuonyesha kwa uwazi mambo muhimu
          yafuatayo:-
        </span>
        <li>Jina la Chama</li>
        <li>
          Anuani kamili, ikiwa na Mtaa au Kijiji, namba ya nyumba au Ofisi,
          namba ya sanduku la Posta na Simu kama ipo na pia Mji, Wilaya na Mkoa;
        </li>
        <li>Madhumuni;</li>
        <li>Idadi na aina ya Michezo;</li>
        <li>Muundo wa Chama;</li>
        <li>Wajibu na kazi za Kamati mbalimbali</li>
        <li>Wajibu na kazi za Viongozi na Wanachama;</li>
        <li>
          viii. Kalenda ya:
          <ul
            role="list"
            class="list-decimal pl-5 space-y-3 text-gray-500 mt-2"
          >
            <li>Mikutano ya Kamati ndogo ndogo;</li>
            <li>Mikutano ya Kamati ya Utendaji;</li>
            <li>Mikutano Mikuu;</li>
            <li>Mkutano Mkuu wa Uchaguzi.</li>
            <li>Taratibu za kushuguhulikia migogoro na rufaa;</li>
            <li>Vipindi vya Uongozi;</li>
            <li>
              Sifa za Wagombea Uongozi ziwekwe bayana, kulingana na aina ya
              mchezo, utaalam,uzoefu, kiwango cha Elimu na ngazi ya chama husika
              kwa mujibu wa Sera ya Maendeleo nya Michezo.
            </li>
            <li>
              Kila Katiba ionyeshe kuwa Chama kitafanya kazi zake chini ya
              Sheria Na. 12 ya BMT ya mwaka 1967.
            </li>
          </ul>
        </li>
      </ul>
    </>
  );
};

export default Second;
